import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import useResponsive from '../../hooks/useResponsive';
import './ContactSection.scss';

const ContactSection: React.FC = () => {
  const { isMobile } = useResponsive();
  
  return (
    <section className="contact-section" id="contact">
      <Container>
        <h2 className="section-title">¡Contáctanos!</h2>
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <p className="section-description">
              ¡Nos encantaría saber de ti! Por favor, contáctanos y nos pondremos en contacto contigo para responder tus preguntas
              y explorar cómo podemos trabajar juntos para alcanzar tus objetivos empresariales.
            </p>
          </Col>
        </Row>
        
        <Row className="justify-content-center mt-4">
          <Col md={6}>
            <Card className="contact-card">
              <Card.Body className="text-center">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faEnvelope} size={isMobile ? "2x" : "3x"} />
                </div>
                <h3 className="mt-4">Envíanos un correo</h3>
                <p className="mb-4">
                  Nuestro equipo de soporte está listo para ayudarte con cualquier pregunta o solicitud.
                </p>
                <a href="mailto:soporte@codetrend.net" className="contact-email">
                  soporte@codetrend.net
                </a>
                <p className="mt-4 response-time">
                  Tiempo de respuesta: 24-48 horas hábiles
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;